import script from "./TinyCopyBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./TinyCopyBox.vue?vue&type=script&setup=true&lang=ts"

import "./TinyCopyBox.vue?vue&type=style&index=0&id=a85c3436&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a85c3436"]])

export default __exports__